import React, { Component } from 'react'
import Link from '../Link'
import styles from './Menu.css'

export default class Menu extends Component {
  state = {
    droppedDown: false,
  }
  handleBurgerClick = () => {
    this.setState({droppedDown: !this.state.droppedDown})
  }
  handleItemClick = () => {
    this.setState({droppedDown: false})
  }

  render () {
    return (
      <div className={styles.cont +' '+ (this.state.droppedDown ? styles.active : '')}>
        {
          this.props.linkBack ? (
            <Link to='/tour' className={styles.navigateBack}/>
          )
          : (
            <a
              href={this.props.logo.url}
              className={styles.logo}
            />
          )
        }
      
        <Link to='/tour/map' className={styles.map} onClick={this.handleItemClick}>
          Map
        </Link>
       
        
        <div className={styles.sep}/>
        <div className={styles.burger +' '+ (this.state.droppedDown ? styles.active : '')} onClick={this.handleBurgerClick}/>
        <div className={styles.items +' '+ (this.state.droppedDown ? styles.active : '')}>
          {
            this.props.menu.map( item => <Item key={item.text} item={item} onClick={this.handleItemClick}/> )
          }
        </div>

      </div>
    )
  }
}

class Item extends Component {
  render () {
    return (
      <Link className={styles.item} to={this.props.item.url} onClick={this.props.onClick}>
        {this.props.item.text}
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/Menu/index.js